// extracted by mini-css-extract-plugin
module.exports = {"user":"styles_user__bAv_s"};